import uniq from 'lodash/uniq'

const collectCategoryIdsFromChildren = (children = []) =>
  uniq(children.flatMap((node) => node.categoryIds || []))

export const buildRelatedProductFilter = ({
  source = 'premium',
  level,
  globalNode = null,
  outletGlobalNode = null,
  categoryNode = null,
  subcategoryNode = null,
}) => {
  if (source === 'outlet') {
    if (level === 'outlet_root') {
      return { catalogSources: ['outlet'], categoryIds: null, subcategoryIds: null }
    }

    if (level === 'global') {
      return {
        catalogSources: ['outlet'],
        categoryIds: collectCategoryIdsFromChildren(outletGlobalNode?.children),
        subcategoryIds: null,
      }
    }

    if (level === 'category') {
      return {
        catalogSources: ['outlet'],
        categoryIds: categoryNode?.categoryIds || [],
        subcategoryIds: null,
      }
    }

    if (level === 'subcategory') {
      return {
        catalogSources: ['outlet'],
        categoryIds: null,
        subcategoryIds: subcategoryNode?.subcategoryIds || [],
      }
    }
  }

  if (level === 'global') {
    return {
      catalogSources: ['premium'],
      categoryIds: collectCategoryIdsFromChildren(globalNode?.children),
      subcategoryIds: null,
    }
  }

  if (level === 'category') {
    return {
      catalogSources: ['premium'],
      categoryIds: categoryNode?.categoryIds || [],
      subcategoryIds: null,
    }
  }

  if (level === 'subcategory') {
    return {
      catalogSources: ['premium'],
      categoryIds: null,
      subcategoryIds: subcategoryNode?.subcategoryIds || [],
    }
  }

  return { catalogSources: ['premium', 'outlet'], categoryIds: null, subcategoryIds: null }
}

export default buildRelatedProductFilter
